import { franc } from "franc-min";

function detectLanguage(text) {
    const langCode = franc(text); // Detect language
    const fontFamilyDescription = {
      tel: {
        fontFamily:"Lohit Telugu",
        fontSize: "17px",
        lineHeight: "26px",
      },
      hin: {
        fontFamily:"Lohit Devanagari",
        fontSize: "14.4px",
        lineHeight: "25px",
        letterSpacing: "0.2px",
      },
      tam: {
        fontFamily:"Lohit Tamil",
        fontSize: "15px",
        lineHeight: "22px",
        letterSpacing: "0.5px",
      },
      kan: {
        fontFamily:"NotoSans Kannada" ,
        fontSize: "16px",
        lineHeight: "24px",
      },
      mal: {
        fontFamily:"NotoSans Malayalam",
      fontSize: "13px",
      lineHeight: "24px",
      letterSpacing:'0.4px'
    },
      guj: {
        fontFamily:"Lohit Gujarati",
      fontSize: "15px",
      lineHeight: "24px",
      letterSpacing:'0.5px'
    },
      mar: {
        fontFamily:"Lohit Devanagari",
        fontSize: "14.4px",
        lineHeight: "25px",
        letterSpacing: "0.2px",
      },
      ben: {
        fontFamily:"Lohit Bengali",
        fontSize: "15.4px",
        lineHeight: "25px",
        letterSpacing: "0.2px",
      },
    };

    const FontFamilyHeading ={
      tel: {
        fontFamily:"Ramabhadra Regular",
        fontSize: "19px",
        lineHeight: "22px",
      },
      hin: {
        fontFamily:"Lohit Devanagari",
        fontSize: "19px",
        lineHeight: "22px",
      },
      tam: {
        fontFamily:"NotoSans Tamil SemiBold",
        fontSize: "15px",
        lineHeight: "22px",
      },
      kan: {
        fontFamily:"NotoSans Kannada" ,
        fontSize: "16px",
        lineHeight: "22px",
        fontWeight: "700",
      },
      mal: {
        fontFamily:"NotoSans Malayalam",
        fontSize: "16px",
        lineHeight: "22px",
        fontWeight: "700",
    },
      guj: {
        fontFamily:"Lohit Gujarati",
        fontSize: "17px",
        lineHeight: "22px",
        fontWeight:'700'
    },
      mar: {
        fontFamily:"Lohit Devanagari",
        fontSize: "19px",
        lineHeight: "22px",
      },
      ben: {
        fontFamily:"Lohit Bengali",
        fontSize: "17px",
        lineHeight: "22px",
        fontWeight: "700",
      },
    };
    return {
      heading: FontFamilyHeading[langCode],
      descrip: fontFamilyDescription[langCode],
    }
  }

  export default detectLanguage;